import React from 'react';

import PanelIconTitle from '../PanelIconTitle/PanelIconTitle';

interface IRightSidePanelSectionProps {
  children: any;
  title?: string;
}

export default function RightSidePanelSection({ children, title }: IRightSidePanelSectionProps) {
  return (
    <div className="mb-20 mt-20 ml-5">
      {title && (
        <PanelIconTitle>{title}</PanelIconTitle>
      )}

      {children}
    </div>
  );
}
